import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import {
  isMobile
} from "react-device-detect";

class Pricepopup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      open : false,
      selectedTab: null,
      tabs : [],
      allPrice : [],
      selectPrice : [],
      is5G: false
    };
    this.searchTextObj = null;

  }
  componentDidMount()
  {
  //  this.dataLoad();
  }
  dataLoad(isNoPropsCall , is5G)
  {
    var self = this;
    var TabArray = [];
    $.get('https://api.tfamily.co.kr/api/mobile/fees',{},function(data){
      var price = JSON.parse(data);
      var allPrice = [];
      let default_price = null;
      for ( var i = 0 ; i < price.data.length ; i++)
      {
        var list = price.data[i];
        for ( var j = 0 ; j < list.fees.length; j++ )
        {
          var fee = list.fees[j];
          fee.tabname = list.name;

          var matchesNetwork = is5G ? fee.is_5g === 1 : fee.is_5g !== 1;
          if( matchesNetwork ) {
            allPrice.push(fee);
            if( fee.is_default == 1 && !default_price ) {
              default_price = fee;
            }
          }
        }
      }
      if( !isNoPropsCall ) {
        var selected = default_price || allPrice[0];
        if( selected ) {
          self.props.onPriceChanged(selected);
        }
      }
      if( is5G ) {
        for( var i = 0; i < price.data.length; i++) {
          if( price.data[i].is_5g === 1 ) {
            TabArray.push({
              name: price.data[i].name,
              is_5g: price.data[i].is_5g,
              fees: price.data[i].fees
            });
          }
        }
      } else {
        for( var i = 0; i < price.data.length; i++) {
          if( price.data[i].is_5g !== 1 ) {
            TabArray.push({
              name: price.data[i].name,
              is_5g: price.data[i].is_5g,
              fees: price.data[i].fees
            });
          }
        }
      }
      self.setState({
        tabs : TabArray,
        allPrice : allPrice,
        selectPrice : allPrice
      });
    });
  }
  Open(isNoPropsCall, is5G)
  {
    this.setState({ open: true, is5G: is5G });
    this.dataLoad(isNoPropsCall, is5G );
  }
  Close()
  {
    this.setState({ open: false });
  }
  onCloseModal()
  {
    this.setState({ open: false });
  }
  priceSelect(price)
  {
    this.props.onPriceChanged(price);
    this.onCloseModal();
    //this.props.onPriceChanged();
  }
  hashString(s)
  {
    var h = 0, l = s.length, i = 0;
    if ( l > 0 )
      while (i < l)
        h = (h << 5) - h + s.charCodeAt(i++) | 0;
    return h;
  }
  tabChange(t)
  {
    this.searchTextObj.value = '';
    var selectedTab = t;
    if( !t )
    {
      this.setState({
        selectPrice : this.state.allPrice,
        selectedTab : selectedTab
      });
      return true;
    }
    const id = this.hashString(t);
    const tabs = this.state.tabs;
    for(var i = 0 ; i < tabs.length ; i++)
    {
      var list = tabs[i];
      if( id == this.hashString(list.name))
      {
        this.setState({
          selectPrice:list.fees,
          selectedTab : selectedTab
        });
      }
    }
  }
  handleChange()
  {
    var insertTxt = this.searchTextObj.value;
    var searchPrice = [];
    var nowPrice = [];
    var tabs = this.state.tabs;

    for( var i = 0 ; i < tabs.length; i++ )
    {
      if( tabs[i].name == this.state.selectedTab )
      {
        nowPrice = tabs[i].fees;
      }
    }

    if ( !this.state.selectedTab )
    {
      nowPrice = this.state.allPrice;
    }

    for( var i = 0 ; i < nowPrice.length ; i++ )
    {
      var name = nowPrice[i].name;
      var result = name.toLowerCase().indexOf(insertTxt.toLowerCase())
      if( result != -1 )
      {
        searchPrice.push(nowPrice[i]);
      }
    }

    if( insertTxt == '' )
    {

    }

    this.setState({
      selectPrice : searchPrice
    });

  }
  render()
  {
    var self = this;

    return(<Modal open={this.state.open} onClose={()=>{self.onCloseModal()}} center>
        <div className="modal-dialog modal-lg mb0">
          <div className="popupPadding pr45">
            <div className="row">
              <div className="col-xs-12 col-md-2">
                <div className="searchTitle">요금제 선택</div>
              </div>
              <div className="col-xs-12 col-md-9">
                <input type="text" onChange={()=>this.handleChange()} ref={(ref)=>{this.searchTextObj = ref}} className="form-control searchbar non-radius" />
              </div>
              {(isMobile) ? null : <div className="col-xs-1 col-md-1">
                <img src={'/img/search.png'} />
              </div> }

            </div>
            <div className="row pt20">
              <ul className="nav nav-pills nav-justified">
                <li role="presentation" className={ self.state.selectedTab == null ? 'active' : ''}><a href="#all" onClick={()=>{self.tabChange()}} >전체</a></li>
                {self.state.tabs.map(tab=>{
                  return (<li key={'price'+self.hashString(tab.name)} role="presentation" className={self.state.selectedTab == tab.name ? 'active' : ''} onClick={()=>self.tabChange(tab.name)}><a>{tab.name}</a></li>)
                })}
              </ul>
            </div>
            <div className="row linetop">
                <table className="table priceTable">
                  <thead>
                    <tr className="width100percent" >
                        <th  className="col-md-3 text-center">요금제</th>
                        <th  className="col-md-3 text-center">월정액</th>
                        {(isMobile) ? null : <th  className="col-md-2 text-center pr0important">유무선전화</th> }
                        {(isMobile) ? null : <th  className="col-md-2 text-center pr0important">데이터</th> }
                        {(isMobile) ? null : <th  className="col-md-2 text-center pr0important">문자</th> }
                    </tr>
                  </thead>
                  <tbody className="Height400 scroll-tbody-y">
                  {
                    self.state.selectPrice.map(price=>{
                      return (<tr className="width100percent" onClick={()=>{this.priceSelect(price)}} key={'price' + price.idx}>
                          <td className="col-md-3">{price.name}</td>
                          <td className="col-md-3"><b>월 정액 {price.price}원</b></td>
                          {(isMobile) ? null : <td className="col-md-2 hidden-md hidden-sm hidden-xs pr0important"><div className="text-center border-right pr10 pl10">{price.call_amt}</div></td> }
                          {(isMobile) ? null : <td className="col-md-2 hidden-md hidden-sm hidden-xs pr0important"><div className="text-center border-right pr10 pl10">{price.data_amt}</div></td> }
                          {(isMobile) ? null : <td className="col-md-2 hidden-md hidden-sm hidden-xs pr0important"><div className="text-center pr10 pl10">{price.sms_amt}</div></td> }
                        </tr>);
                    })
                  }
                  </tbody>
                </table>
            </div>
          </div>
        </div>
    </Modal>);
  }
}

export default Pricepopup;

